<!-- 由 suu 创建于 2021-01-06 星期三 -->
<template>
  <div class="training-pro">
    <!-- <van-empty description="暂无训练评估" v-if="uid == 'null'" />
    <template v-else>
      <trainingProTop @getUid="onGetUid"></trainingProTop>
      <div class="tp-list">
        <div class="list-title">评估列表</div>
        <div class="list-no" v-if="!list.length && !bodyAssessList.length">
          暂无评估记录
        </div>
        <div
          class="tp-item"
          @click="showCon(item)"
          v-if="
            (ufrom != 'vip' || (ufrom == 'vip' && item.status == 1)) &&
            item.level != 4
          "
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="i-left">
            <div class="i-title">
              {{ item.day.slice(0, 7).replace(/\./, '-') }}期{{
                item.temp_title
              }}
            </div>
            <div class="i-info">
              <span class="i-dates"> 评估时间：{{ item.day }} </span>
              <span class="i-line"></span>
              {{ item.creator }}编写
              <span class="i-line"></span>
              <span :class="{ 'status-off': item.status == 0 }">{{
                stateArr[item.status]
              }}</span>
            </div>
            <div class="i-time" v-if="item.submit_time && ufrom != 'vip'">
              发布时间：{{ item.submit_time }}
            </div>
          </div>
          <div class="i-right">
            <i
              class="el-icon-arrow-right"
              v-if="ufrom == 'vip' || !item.isEdit"
            ></i>
            <div class="i-btn user-btn" v-else @click.stop="handelEdit(item)">
              编辑
            </div>
          </div>
        </div>
        <template v-if="bodyAssessList.length">
          <div
            class="tp-item"
            @click="toBodyAssessDetail(item, index)"
            v-for="(item, index) in bodyAssessList"
            :key="item.id"
          >
            <div class="i-left">
              <div class="i-title">
                {{ item.date_time.slice(0, 7).replace(/\./, '-') }}期{{
                  assessArr[item.t_type]
                }}
              </div>
              <div class="i-info">
                {{ item.date_time.split(' ')[0].replace(/-/g, '.') }}
                <span class="i-line"></span>
                {{ item.coach }}编写
                <span class="i-line"></span>
                <span>已发布</span>
              </div>
            </div>
            <div class="i-right">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </template>
      </div>
      <div
        class="footer-btn u-text-center user-btn"
        v-if="ufrom != 'vip'"
        @click="addPro"
      >
        添加训练评估
        <span>+</span>
      </div>
    </template> -->
    <AppLoading class="app-loading" />
  </div>
</template>

<script>
import { Empty } from 'vant'
import trainingProTop from './ponents/training-pro-top'
import AppLoading from '@/components/app/loading/loading.vue'

export default {
  name: 'training-pro',

  components: { trainingProTop, [Empty.name]: Empty, AppLoading },

  props: {},

  data() {
    return {
      ufrom: this.$route.query.ufrom || 'vip', // 当前用户来源  app中默认身份 vip 为会员用户
      uid: this.$store.state.user.user.uid,
      // 老版体测类型
      assessArr: {
        2: '身体评估',
        3: '月度体测'
      },
      levelArr: {
        1: '初阶版',
        2: '中阶版',
        3: '高阶版',
        4: '老版体测',
        5: '简单版',
        6: '综合版'
      },
      stateArr: {
        0: '未发布',
        1: '已发布',
        '-1': '已失效'
      },
      list: [],
      bodyAssessList: [] // 老版 月度体测
    }
  },

  computed: {},

  watch: {},

  activated() {
    // 新增后刷新
    // if (
    //   sessionStorage.getItem('traningRe') &&
    //   sessionStorage.getItem('traningRe') * 1 === 1
    // ) {
    //   sessionStorage.removeItem('traningRe')
    //   this.getInfo()
    // }
  },
  beforeCreate() {
    // this.$http._toVueH5Url('training-pro' + location.search)
    if (!sessionStorage['training-pro-replaceUrl']) {
      this.$http.get('member/index?a=shareLogPush', {
        from: `训练评估-曝光-app`,
        from_id: 250326
      })
      location.replace(
        this.$http._getVueH5Url('training-pro' + location.search)
      )
      sessionStorage['training-pro-replaceUrl'] = 1
    } else {
      sessionStorage.removeItem('training-pro-replaceUrl')
      this.$betterwe.onWebViewBack()
    }
  },

  created() {
    // this.uid =
    //   this.$route.query.uid ||
    //   this.$route.query.userid ||
    //   this.$store.state.user.user.uid ||
    //   ''
    // this.getInfo()
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 获取uid  防止链接不带uid
     */
    onGetUid(e) {
      if (!this.uid && !this.bodyAssessList.length) {
        this.uid = e.uid
        // 请求老版 月度体测
        // this.getBodyAssess()
      }
    },
    /**
     * 已完结的查看总结页面
     */
    showCon(item) {
      // 老版体测不能进入总览页
      if (item.status === 1 && item.level * 1 !== 4) {
        this.$router.push(
          `/training-pro-overview?ufrom=${this.ufrom}&uid=${this.uid}&tpid=${item.id}&level=${item.level}`
        )
      }
    },
    /**
     * 编辑已有规划
     */
    handelEdit(item) {
      // 进入默认curTab 为1
      this.$store.commit('setTrainingProCurTab', -100)
      this.$router.push(
        `/training-pro-add?uid=${this.uid}&tpid=${item.id}&level=${item.level}`
      )
    },
    /**
     * 新增规划
     */
    addPro() {
      this.$router.push('/training-pro-grade?uid=' + this.uid)
    },
    /**
     * 获取列表
     */
    getInfo() {
      this.$toast.loading('加载中···')
      this.$http
        .get(
          'coach/BodyData?a=physicals',
          {
            uid: this.uid
          },
          true
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.list = res.data.data
            // 请求老版体测 月度评估
            // if (this.uid && !this.bodyAssessList.length) {
            //   this.getBodyAssess()
            // }
          } else {
            this.$dialog.alert({ message: res.data.msg })
          }
          this.$toast.clear()
        })
        .catch((err) => {
          this.$dialog.alert({ message: '网络错误' })
          this.$toast.clear()
        })
    },
    getBodyAssess(year = '', month = '') {
      const uid = this.uid || ''
      this.$http
        .post2('dataview/detc', {
          uid,
          year,
          month
        })
        .then((res) => {
          if (res && (res.data.status === 200 || res.data.status === 201)) {
            this.bodyAssessList = res.data.data.assessList
          }
          // Indicator.close();
        })
        .catch((err) => {
          // Indicator.close();
        })
    },
    toBodyAssessDetail(item, index) {
      if (item.id) {
        const uid = this.uid
        const qid = item.id
        const dateTime = item.date_time.substring(0, 11) || 0
        let path = ''
        if (item.t_type * 1 === 2) {
          path = 'physicalassess'
        } else if (item.t_type * 1 === 3) {
          path = 'monthbodyassess'
        }
        path =
          qid > 0
            ? `${path}?uid=${uid}&qid=${qid}&date_time=${dateTime}`
            : `${path}?uid=${uid}&date_time=${dateTime}`
        // this.$router.push(path);
        location.href = 'https://member3.gymcity.com.cn/#/' + path + '&read=1'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.training-pro {
  width: 100vw;
  min-height: 100vh;
  background-color: #f7f7f7;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 15vw;
  color: #000;
  text-align: left;
  .app-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .tp-list {
    width: 100%;
    box-sizing: border-box;
    margin-top: 2.7vw;
    padding: 3.2vw 4.3vw;
    background-color: #ffffff;
    .list-title {
      font-size: 4vw;
      font-weight: 600;
      margin-bottom: 2.7vw;
    }
    .list-no {
      text-align: center;
      padding: 2vw 0;
      font-size: 3.2vw;
      color: #666;
    }
    .tp-item {
      width: 100%;
      box-sizing: border-box;
      padding: 3.2vw;
      background-color: #ffffff;
      border-radius: 1.6vw;
      border: solid 0.3vw #f1f1f1;
      display: flex;
      align-items: center;
      .i-left {
        .i-title {
          font-size: 3.7vw;
          font-weight: 600;
        }
        .i-info {
          font-size: 3.2vw;
          margin-top: 1vw;
          color: #8e8e8e;
          display: flex;
          align-items: center;
          .i-line {
            width: 0.3vw;
            height: 3vw;
            background-color: #8e8e8e;
            margin: 0 2vw;
          }
          .status-off {
            color: #dc0050;
          }
        }
        .i-time {
          font-size: 3.2vw;
          margin-top: 1vw;
          color: #8e8e8e;
        }
      }
      .i-right {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        .i-btn {
          font-size: 4vw;
          color: #2882e9;
          font-weight: 600;
        }
      }
    }
    .tp-item + .tp-item {
      margin-top: 3vw;
    }
  }
  .footer-btn {
    width: 100%;
    box-sizing: border-box;
    background-color: #2882e9;
    height: 11.7vw;
    font-size: 4.3vw;
    font-weight: 600;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 19;
    color: #fff;
    span {
      font-size: 8vw;
      margin-left: 2.7vw;
    }
  }
}
</style>
